module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"heading":"Qr-Code","deviceName":"Gerätename: %{deviceName}","deviceLabel":"Gerätelabel: %{deviceLabel}","deviceId":"Geräte ID: %{deviceId}"},"en":{"heading":"Qr-Code","deviceName":"Device name: %{deviceName}","deviceLabel":"Device label: %{deviceLabel}","deviceId":"Devide id: %{deviceId}"}}')
  delete Component.options._Ctor
}
